import { message, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import liracrypt from '../components/Liracrypt/liracrypt';
import { createRoute } from '../utils/CustomFunc';
import { useSelector } from 'react-redux';
import {
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    LoadingOutlined,
    SolutionOutlined,
    MobileOutlined,
    ControlOutlined,
    FileJpgOutlined,
    DownloadOutlined,
    AuditOutlined,
    ProfileOutlined,
    FileDoneOutlined,
    UpSquareOutlined,
    DownSquareOutlined,
    PieChartOutlined,
    BarChartOutlined,
    ApartmentOutlined,
    EllipsisOutlined,
    HolderOutlined,
    MenuOutlined,
    RightSquareOutlined,
    LeftSquareOutlined,
    MenuUnfoldOutlined,
    BarcodeOutlined
} from "@ant-design/icons";
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const CorporatePlant = ({
    setPageHeader
}) => {
    const icons = {
        EllipsisOutlined,
        HolderOutlined,
        MenuOutlined,
        EditOutlined,
        DeleteOutlined,
        EyeOutlined,
        LoadingOutlined,
        SolutionOutlined,
        MobileOutlined,
        ControlOutlined,
        FileJpgOutlined,
        DownloadOutlined,
        AuditOutlined,
        ProfileOutlined,
        FileDoneOutlined,
        UpSquareOutlined,
        DownSquareOutlined,
        PieChartOutlined,
        BarChartOutlined,
        ApartmentOutlined,
        RightSquareOutlined,
        LeftSquareOutlined,
        MenuUnfoldOutlined,
        BarcodeOutlined
    }
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const urlCode = useSelector(state => state.urlCode);
    const [pageData, setPageData] = useState();
    const [loading, setLoading] = useState(true);
    const IconComponent = (props) => {
        const Icon = props.icon;
        return Icon ? <Icon {...props} /> : <></>
    }

    const getData = () => {
        liracrypt.get('/textapi', { ...searchParams })
            .then(({ data }) => {
                if (data.isSuccess) {
                    if (setPageHeader) {
                        setPageHeader(data.config.pageTitle || 'Corporate Plant');
                    }
                    setPageData({
                        config: data.config,
                        data: data.data
                    })
                    setLoading(false);
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                console.log(err);
                ApiErrorComp();
            })
    }

    useEffect(() => {
        getData();
    }, [search]);

    useEffect(() => {
        if (pageData?.config?.interval) {
            let interval = setInterval(() => {
                getData();
            }, pageData?.config?.interval);
            return () => clearInterval(interval);
        }
    }, [pageData?.config?.interval]);

    const navigateToRoute = (route) => {
        if (route.includes('http')) {
            window.open(route, '_blank');
        } else {
            let _route = createRoute({
                route,
                urlCode
            });
            window.open(_route, '_blank');
        }
    }

    return (
        <div>
            {
                loading ?
                    <div className='Loading'>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 60 }} />} />
                    </div> :
                    <>
                        {
                            pageData.data.map((item, indx) => (
                                <div className={"corporate-plant-wrapper"} key={indx}>
                                    <p style={item.titleStyle}>{item.title}</p>
                                    <div className={"corporate-plant-btn-wrapper"}>
                                        {
                                            item.buttons.map((btn, btnIndx) => (
                                                <div
                                                    key={`btn-${btnIndx}`}
                                                    style={btn.style}
                                                    onClick={() => {
                                                        navigateToRoute(btn.route)
                                                    }}
                                                >
                                                    <div style={{ display: "block", textAlign: "center" }}>
                                                        {
                                                            btn.img ?
                                                                <img src={btn.img.url} style={{ ...btn.img.style }} /> :
                                                                <IconComponent icon={icons[btn.icon]} style={{ paddingLeft: 10, fontSize: 30 }} />

                                                        }
                                                        <div style={{ padding: 0, margin: 0, paddingTop: 10 }}>{btn.label}</div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </>
            }

        </div>
    )
};

export default CorporatePlant;